import { createSlice } from "@reduxjs/toolkit";
import { paymentTypes } from "../../services/Braintree";

const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    zipcode: "",
    salesTaxAmount: 0,
    salesTaxState: "",
    paypalAccount: "",
    paymentType: paymentTypes.CREDIT_CARD,
    promoCode: "",
    promoCodeApplied: "",
    promoDiscountAmount: "",
    promoDiscountAmountFormatted: "",
    promoDiscountPercentage: 0,
    promoCodeIsVip: false,
    promoCodeError: "",
    purchaseError: "",
    processing: false,
    goalMonth: "",
    // TODO(patrick): Move these modal states out of redux and into the component states if possible.
    madeTrialPriceChoice: false,
    showFairTrialDisclaimer: false,
    shouldShowExitIntentModal: false,
    showExitIntentModal: false,
    isTimerExpired: false,
  },
  reducers: {
    updateCheckoutState(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const { updateCheckoutState } = checkoutSlice.actions;

export default checkoutSlice.reducer;
